module dg.objects {

    export class FormErrorsController implements ng.IController {
        public errors: Array<any>;

        $onInit() {

        }

        public closeAlert = (index) => {
            this.errors.splice(index, 1);
        };
    }

    angular.module('dg.objects').component('formErrors', {
        bindings: {
            errors: '<'
        },
        controller: FormErrorsController,
        templateUrl: '/digmo/src/objects/form-errors.html'
    });
}